interface LinkAppProps {
  text: string;
  Icon: React.ElementType;
  href: string; 
 
  target?: string; 
}

export const LinkApp: React.FC<LinkAppProps> = ({ text, Icon, href, target = '_blank' }) => {
  return (
    <a href={href} className='w-32 text-sm font-semibold no-underline flex items-center justify-start gap-1 bg-white border-2 border-slate-600 rounded-lg py-1.5 px-0.5' target={target}>
      <Icon />
      {text}
    </a>
  );
};
